import { useSelector } from "react-redux";

export const useSession = () => {
  const user = useSelector((state) => state.auth.info);

  return { user }

}